/**
 * DOM-Hilfsfunktionen für den LoginScreen.
 * Erstellt gestylte Input-, Button- und Tab-Elemente.
 */

const INPUT_STYLE: Record<string, string> = {
  width: '100%', boxSizing: 'border-box', background: '#0a0e1a',
  border: '1px solid #334', color: '#ccc', padding: '10px 12px',
  fontFamily: 'monospace', fontSize: '14px', borderRadius: '6px',
  marginBottom: '12px', outline: 'none', minHeight: '44px',
};

export function createInput(placeholder: string, type: string): HTMLInputElement {
  const el = document.createElement('input');
  el.type = type;
  el.placeholder = placeholder;
  Object.assign(el.style, INPUT_STYLE);
  el.addEventListener('focus', () => { el.style.borderColor = '#8cf'; });
  el.addEventListener('blur', () => { el.style.borderColor = '#334'; });
  return el;
}

export function createButton(text: string): HTMLButtonElement {
  const btn = document.createElement('button');
  btn.textContent = text;
  Object.assign(btn.style, {
    width: '100%', background: '#1a3a5a', color: '#8cf', border: '1px solid #4a6a8a',
    padding: '12px', fontFamily: 'monospace', fontSize: '14px',
    borderRadius: '6px', cursor: 'pointer', marginTop: '4px', letterSpacing: '1px',
    outline: 'none', minHeight: '44px',
  });
  btn.addEventListener('mouseenter', () => { btn.style.background = '#2a4a6a'; });
  btn.addEventListener('mouseleave', () => { btn.style.background = '#1a3a5a'; });
  return btn;
}

export function createTabBtn(text: string, active: boolean): HTMLButtonElement {
  const btn = document.createElement('button');
  Object.assign(btn.style, {
    flex: '1', background: 'none', border: 'none', borderBottom: '2px solid',
    borderBottomColor: active ? '#8cf' : 'transparent',
    color: active ? '#8cf' : '#556', fontFamily: 'monospace',
    fontSize: '13px', padding: '8px 0', cursor: 'pointer', letterSpacing: '1px',
    outline: 'none',
  });
  btn.textContent = text;
  return btn;
}

export function createMsgBox(color: string): HTMLDivElement {
  const el = createDiv({
    display: 'none', color, fontFamily: 'monospace', fontSize: '12px',
    padding: '8px', marginBottom: '12px', textAlign: 'center',
  });
  return el;
}

export function createDiv(style: Record<string, string>): HTMLDivElement {
  const el = document.createElement('div');
  Object.assign(el.style, style);
  return el;
}

export function inputStyle(): Record<string, string> {
  return { ...INPUT_STYLE };
}
